export const HISTORY_LIST_REQUEST = "HISTORY_LIST_REQUEST";
export const HISTORY_LIST_SUCCESS = "HISTORY_LIST_SUCCESS";
export const HISTORY_LIST_FAIL = "HISTORY_LIST_FAIL";
